import { DevLogger } from './development';
import { DynatraceLogger } from './dynatrace';
export function createLoggerService(deps) {
  const {
    logger,
    devLogger = new DevLogger()
  } = deps;
  return {
    getInstance() {
      return process.env.NODE_ENV === 'production' ? logger : devLogger;
    },
    sendError(err, ...args) {
      this.getInstance().logError(err, ...args);
    }
  };
}
export const loggerService = createLoggerService({
  logger: new DynatraceLogger()
});